import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";
import {
  addEithPlotChangeListnerForAddress,
  convertAddressToLowerCase,
  getEithProcessingPlotsData,
} from "../../actions/DataActions";
import { PLOT_STATUS } from "../../utils/constants/config";
import useGetAddress from "../walletsManagment/useGetAddress";
import ModalProcessingTransactions from "../modal/ModalProcessingTransactions";
import ModalPurchaseCongrat from "../modal/ModalPurchaseCongrat";
import ModalInventoryDetail from "../modal/ModalInventoryDetail";
import ModalFailure from "../modal/ModalFailure";
import ModalBuyPlot from "../modal/ModalBuyPlot";
import { closeDark } from "../../assets";
import ModalBuyCondo from "../modal/ModalBuyCondo";
import { AppContext } from "../walletsManagment/connectors";
const TrasactionsNotificatios = ({ chain }) => {
  const refViewedTxn = useRef([]);
  const [state, setState] = useState({
    processingPlots: [],
    failedTransactions: [],
    completedTransaction: [],
    showProcesesingTxns: false,
    showCongratulate: false,
    isShowDetail: false,
    showFailureDetail: false,
    selectedPlot: false,
    showBuyModal: false,
  });
  const firestoreSubscriberRef = useRef([]);
  const { eithAuthToken } = useContext(AppContext);
  const account = useGetAddress(chain);

  let getProcessingPlots = () => {
    getEithProcessingPlotsData(account)
      .then((prociingPlots) => {
        setState((state) => ({ ...state, processingPlots: prociingPlots }));
      })
      .catch((er) => {
        console.log("Ex:", er);
        setState((state) => ({ ...state, processingPlots: [] }));
      });
  };

  useEffect(() => {
    if (account && eithAuthToken) {
      setTimeout(() => {
        getProcessingPlots();
      }, 2000);
    } else {
      setState((state) => ({
        ...state,
        processingPlots: [],
        failedTransactions: [],
        completedTransaction: [],
      }));
    }
  }, [account, eithAuthToken]);

  useEffect(() => {
    if (account != null) {
      addListener();
    }

    return () => {
      firestoreSubscriberRef.current?.map((subs) => {
        subs();
      });
    };
  }, [account]);

  const addListener = () => {
    firestoreSubscriberRef.current?.map((subs) => {
      subs();
    });

    firestoreSubscriberRef.current = addEithPlotChangeListnerForAddress(
      account,
      (snapshot) => {
        snapshot?.docChanges().forEach((change) => {
          // console.log("TxnChange==>", change);
          if (change?.type === "removed") {
            const removedPlot = change.doc.data();

            if (removedPlot.status == PLOT_STATUS.PROCESSING) {
              setState((state) => {
                _.remove(state.processingPlots, (currentObject) => {
                  return (
                    (removedPlot.plot_id &&
                      currentObject.plot_id == removedPlot.plot_id) ||
                    (removedPlot.id && removedPlot.id == currentObject.id)
                  );
                });

                return {
                  ...state,
                  failedTransactions: [
                    ...state.failedTransactions,
                    removedPlot,
                  ],
                  processingPlots: [...state.processingPlots],
                };
              });
            }
          } else if (change?.type === "added") {
            const modifiedPlot = change.doc.data();

            if (modifiedPlot.status == PLOT_STATUS.PROCESSING) {
              let alreadyExist = _.find(
                state.processingPlots ?? [],
                (item) =>
                  (modifiedPlot.plot_id &&
                    item.plot_id == modifiedPlot.plot_id) ||
                  (modifiedPlot.id && modifiedPlot.id == item.id)
              );

              if (!alreadyExist && (modifiedPlot.plot_id || modifiedPlot.id)) {
                setState((state) => {
                  return {
                    ...state,

                    processingPlots: [modifiedPlot, ...state.processingPlots],
                  };
                });
              }
            }
          } else if (change?.type === "modified") {
            const modifiedPlot = change.doc.data();
            // console.log("modifiedPlot==>",modifiedPlot)
            if (
              modifiedPlot.status == PLOT_STATUS.SOLD &&
              modifiedPlot.owner_id == convertAddressToLowerCase(account)
            ) {
              setState((state) => {
                let processing = [...state.processingPlots];
                _.remove(processing, (currentObject) => {
                  return (
                    (modifiedPlot.plot_id &&
                      currentObject.plot_id == modifiedPlot.plot_id) ||
                    (modifiedPlot.id && modifiedPlot.id == currentObject.id)
                  );
                });
                let alreadyExist = _.find(
                  state.completedTransaction ?? [],
                  (item) =>
                    (modifiedPlot.plot_id &&
                      item.plot_id == modifiedPlot.plot_id) ||
                    (modifiedPlot.id && modifiedPlot.id == item.id)
                );

                if (alreadyExist) {
                  return {
                    ...state,
                    completedTransaction: [...state.completedTransaction],
                    processingPlots: [...processing],
                  };
                } else {
                  let isViewed = _.find(
                    refViewedTxn.current ?? [],
                    (id) =>
                      (modifiedPlot.plot_id && id == modifiedPlot.plot_id) ||
                      (modifiedPlot.id && id == modifiedPlot.id)
                  );

                  return {
                    ...state,
                    completedTransaction: isViewed
                      ? [...state.completedTransaction]
                      : [...state.completedTransaction, modifiedPlot],

                    processingPlots: [...processing],
                  };
                }
              });
            } else if (modifiedPlot.status == PLOT_STATUS.PROCESSING) {
              let alreadyExist = _.find(
                state.processingPlots ?? [],
                (item) =>
                  (modifiedPlot.plot_id &&
                    item.plot_id == modifiedPlot.plot_id) ||
                  (modifiedPlot.id && modifiedPlot.id == item.id)
              );
              if (!alreadyExist && (modifiedPlot.plot_id || modifiedPlot.id)) {
                setState((state) => {
                  return {
                    ...state,

                    processingPlots: [modifiedPlot, ...state.processingPlots],
                  };
                });
              }
            }
          }
        });
      }
    );
  };

  const handleFailedItemClick = (plotID) => (e) => {
    if (plotID) {
      let txns = state.failedTransactions;
      let plot = _.remove(txns, (currentObject) => {
        return currentObject.plot_id == plotID || currentObject.id == plotID;
      });

      setState((state) => ({
        ...state,
        failedTransactions: [...txns],
        showFailureDetail: true,
        selectedPlot: plot?.length > 0 ? plot[0] : null,
      }));
    }
  };
  const handleFailedItemCloseClick = (plotID) => (e) => {
    if (plotID) {
      let txns = state.failedTransactions;
      _.remove(txns, (currentObject) => {
        return currentObject.plot_id == plotID || currentObject.id == plotID;
      });

      setState((state) => ({
        ...state,
        failedTransactions: [...txns],
      }));
    }
  };
  const handleSuccessItemClick = (plotID) => (e) => {
    if (plotID) {
      let txns = state.completedTransaction;
      let removedPlots = _.remove(txns, (currentObject) => {
        return currentObject.plot_id == plotID || currentObject.id == plotID;
      });
      let plot = removedPlots?.length > 0 ? removedPlots[0] : null;

      if (plot.plot_id || plot.id) {
        refViewedTxn.current.push(plot.plot_id || plot.id);
      }

      setState((state) => ({
        ...state,
        completedTransaction: [...txns],
        showCongratulate: true,
        selectedPlot: plot,
      }));
    }
  };
  const handleSuccessItemCloseClick = (plotID) => (e) => {
    if (plotID) {
      let txns = state.completedTransaction;

      let removedPlots = _.remove(txns, (currentObject) => {
        return currentObject.plot_id == plotID || currentObject.id == plotID;
      });
      let plot = removedPlots?.length > 0 ? removedPlots[0] : null;
      if (plot.plot_id || plot.id) {
        refViewedTxn.current.push(plot.plot_id || plot.id);
      }
      setState((state) => ({
        ...state,
        completedTransaction: [...txns],
      }));
    }
  };
  const handleShowProgressTransactions = () => {
    setState((state) => ({ ...state, showProcesesingTxns: true }));
  };

  const handleTryAgainFailedTxn = () => {
    setState((state) => ({
      ...state,
      showFailureDetail: false,
      showBuyModal: true,
    }));
  };
  return (
    <>
      <div className="transactionNotify overflow-auto h-0">
        {state?.processingPlots?.length > 0 && (
          <div className="relative mt-2">
            <button
              type="button"
              className="notifyslide warning"
              onClick={handleShowProgressTransactions}
            >
              <div className="notifyMsg ">
                {state?.processingPlots?.length}{" "}
                {state?.processingPlots?.length == 1
                  ? "Transaction"
                  : "Transactions"}{" "}
                in progress.
              </div>
            </button>
          </div>
        )}

        {state.completedTransaction?.map((plot) => {
          return (
            <div className="relative" key={plot.plot_id || plot.id}>
              <button
                type="button"
                value={plot.plot_id || plot.id}
                onClick={handleSuccessItemClick(plot.plot_id || plot.id)}
                className="notifyslide success"
              >
                <div className="notifyMsg">
                  Your Transaction has been successfully completed.
                </div>
              </button>

              <span
                className="close "
                value={plot.plot_id || plot.id}
                onClick={handleSuccessItemCloseClick(plot.plot_id || plot.id)}
              >
                <img src={closeDark} alt="" className="img" />
              </span>
            </div>
          );
        })}

        {state.failedTransactions?.map((plot) => {
          return (
            <div className="relative" key={plot.plot_id || plot.id}>
              <button
                type="button"
                value={plot.plot_id || plot.id}
                className="notifyslide fail"
                onClick={handleFailedItemClick(plot.plot_id || plot.id)}
              >
                <div className="notifyMsg">
                  Your Transaction has been failed.
                </div>
              </button>
              <span
                className="close"
                value={plot.plot_id || plot.id}
                onClick={handleFailedItemCloseClick(plot.plot_id || plot.id)}
              >
                <img src={closeDark} alt="" className="img" />
              </span>
            </div>
          );
        })}
      </div>
      {state.showProcesesingTxns && !state.isShowDetail && (
        <ModalProcessingTransactions
          showModal={state.showProcesesingTxns && !state.isShowDetail}
          processingTransections={state.processingPlots}
          handlePlotSelection={(plot) => {
            setState((state) => ({
              ...state,
              isShowDetail: true,
              selectedPlot: plot,
            }));
          }}
          closeModal={() => {
            setState((state) => ({ ...state, showProcesesingTxns: false }));
          }}
        />
      )}

      {/* {state.showBuySuccesModal && (
        <ModalBuyPlotTxnSuccess
          showModal={state.showBuySuccesModal}
          closeModal={()=>{
            setState((state) => ({
              ...state,
              showBuySuccesModal: false,
            }));
          }}
          itemDetail={state.selectedPlot}
        />
      )} */}
      <ModalPurchaseCongrat
        showModal={state.showCongratulate}
        plot={state.selectedPlot}
        closeModal={(showDetail) => {
          if (showDetail) {
            setState((state) => ({
              ...state,
              showCongratulate: false,
              isShowDetail: true,
            }));
          } else {
            setState((state) => ({
              ...state,
              showCongratulate: false,
              selectedPlot: null,
            }));
          }
        }}
      />
      {state.isShowDetail && (
        <ModalInventoryDetail
          showDetail={state.isShowDetail}
          inventory={state.selectedPlot}
          closeModal={() => {
            setState((state) => ({ ...state, isShowDetail: false }));
          }}
        />
      )}

      {state.showFailureDetail && (
        <ModalFailure
          showModal={state.showFailureDetail}
          message={"Your request was unsuccessful! Please try again"}
          closeModal={() => {
            setState((state) => ({
              ...state,
              showFailureDetail: false,
              selectedPlot: null,
            }));
          }}
          closeBtnCallBack={handleTryAgainFailedTxn}
          closeBtnMessage={"Try Again"}
        />
      )}
      {state.showBuyModal&& (
        <ModalBuyPlot
          showModal={state.showBuyModal}
          plotDetail={state.selectedPlot}
          closeModal={() => {
            setState((state) => ({
              ...state,
              showBuyModal: false,
              selectedPlot: null,
            }));
          }}
        />
      )}
      {state.showBuyModal && state.selectedPlot?.condo_id && (
        <ModalBuyCondo
          showModal={state.showCondoPurchase}
          closeModal={() => {
            setState((state) => ({
              ...state,
              showBuyModal: false,
              selectedPlot: null,
            }));
          }}
        />
      )}
    </>
  );
};

export default TrasactionsNotificatios;
